import { render, staticRenderFns } from "./modalEditPhone.vue?vue&type=template&id=4c5760f9&"
import script from "./modalEditPhone.vue?vue&type=script&lang=js&"
export * from "./modalEditPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports